import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloseIcon from '@mui/icons-material/Close';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Link,
  MenuItem,
  Modal,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { paths } from 'src/paths';
import * as Yup from 'yup';
import discardIcon from '../../icons/untitled-ui/duocolor/discardIcon.svg';

import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import patientListIcon from '../../icons/untitled-ui/duocolor/patientListIcon.svg';
import planOfCareIcon from '../../icons/untitled-ui/duocolor/planOfCareIcon.svg';

import { ArrowBackOutlined } from '@mui/icons-material';
import moment from 'moment';
import { useEffect } from 'react';
import DeletePopupModal from 'src/components/common-modals/delete-modal';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';
import {
  createAssessment,
  deleteSingleMdsAssessment,
  getCaseMixGroup,
  getPlanOfCare,
  resetCreateAssessment,
  resetDeleteSingleMdsAssessment,
  resetUpdateAssessment,
  updateAssessment,
} from 'src/redux/actions/therapyPlanning';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import { TrashIcon } from '../therapyPlanning_2.0/commonComponent/therapy-planning-icons';
import FinalBasicDetailsMdsAssessment from './final-basic-details-mds-assessment';

const { therapyPlanning } = paths;

const ntaCaseMixGroup = ['NA', 'NB', 'NC', 'ND', 'NE', 'NF'];

const convertToUTC = (selectedDate: any) => {
  const selectedDateObj = new Date(selectedDate);
  const selectedYear = selectedDateObj.getFullYear();
  const selectedMonth = selectedDateObj.getMonth();
  const selectedDay = selectedDateObj.getDate();

  const systemDateObj = new Date();
  const systemHours = systemDateObj.getHours();
  const systemMinutes = systemDateObj.getMinutes();
  const systemSeconds = systemDateObj.getSeconds();

  // Create combined Date object
  const combinedDate = new Date(
    selectedYear,
    selectedMonth,
    selectedDay,
    systemHours,
    systemMinutes,
    systemSeconds
  );
  return combinedDate?.toISOString();
};
const assessmentTypeList = [
  '5 Day',
  'Interim Payment',
  'Discharge',
  'Quarterly',
  'Annual',
  'Significant Change',
];

const caseMixGroup = [
  'PA1',
  'PA2',
  'PBC1',
  'PBC2',
  'PDE1',
  'PDE2',
  'BAB1',
  'BAB2',
  'CA1',
  'CA2',
  'CBC1',
  'CBC2',
  'CDE1',
  'CDE2',
  'LBC1',
  'LBC2',
  'LDE1',
  'LDE2',
  'HBC1',
  'HBC2',
  'HDE1',
  'HDE2',
  'ES1',
  'ES2',
  'ES3',
];

const ptOtLists = [
  'TA - 60 mins',
  'TB - 90 mins',
  'TC - 120 mins',
  'TD - 160 mins',
  'TE - 190 mins',
  'TF - 120 mins',
  'TG - 120 mins',
  'TH - 120 mins',
  'TI - 120 mins',
  'TJ - 40 mins',
  'TK - 50 mins',
  'TL - 60 mins',
  'TM - 10 mins',
  'TN - 10 mins',
  'TO - 60 mins',
  'TP - 40 mins',
];

const slpLists = [
  'SA - 90 mins',
  'SB - 120 mins',
  'SC - 160 mins',
  'SD - 190 mins',
  'SE - 120 mins',
  'SF - 120 mins',
  'SG - 120 mins',
  'SH - 120 mins',
  'SI - 120 mins',
  'SJ - 120 mins',
  'SK - 120 mins',
  'SL - 120 mins',
];

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '55%',
  borderRadius: '8px',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '250px',
      width: 300,
    },
  },
};

function getCurrentDateUTCWithoutTime(date: any) {
  // Get the date components
  const utcDateFormate = moment(date).format('YYYY-MM-DD');
  // Construct the UTC date string with time portion set to 00:00:00.000Z
  const utcDateString = `${utcDateFormate}T00:00:00.000Z`;

  return utcDateString;
}

const TherapyPlanningEditDetails = () => {
  const [open, setOpen] = useState(false);
  const [warningPopup, setWarningPopup] = useState(false);
  const { state } = useLocation();
  const facilitiesId = localStorage.getItem('facilityId');
  const [data, setData] = useState<any>(null);
  const [ptOtList, setPtOtList] = useState<any>([]);
  const [slpList, setSlpList] = useState<any>([]);
  const facilityCaseMixResponse = useSelector(
    (state: any) => state?.getCaseMixGroupReducer?.response?.data
  );
  const getMultipleMdsAssessment = useSelector((state: any) => state.getMultipleMDSAssessment);

  const selectedPatientList = useSelector((state: any) => state?.selectPatientReducer);
  const getSingleMds = useSelector(
    (state: any) => state.getSingleMdsAssessmentReducer?.response?.data
  );

  useEffect(() => {
    dispatch(getCaseMixGroup());
  }, []);

  const [error, setError] = useState('');
  const action = state?.action;
  const dispatch = useDispatch();
  const selectedPatient = state?.selectedPatient;
  const assessmentDetails = state?.assessmentDetails;
  const assessmentDetailsEditResponse = useSelector((state: any) => state?.updateAssessmentReducer);
  const assessmentDetailsCreateResponse = useSelector(
    (state: any) => state?.createAssessmentReducer
  );
  const eocStartDateWithoutTimeZone = selectedPatient?.eocStartDate?.split('T')?.at(0);

  const isDateInRange = (selectedDate: any) => {
    const eocDate = moment(eocStartDateWithoutTimeZone || new Date());

    const eightDaysAhead = moment(eocStartDateWithoutTimeZone || new Date()).add(7, 'days');

    return (
      selectedDate.isSameOrAfter(eocDate, 'day') &&
      selectedDate.isSameOrBefore(eightDaysAhead, 'day')
    );
  };
  const planOfCareDetails = useSelector(
    (state: any) => state?.getPlanOfCareReducer?.response?.data
  );
  const navigate = useNavigate();
  const patientId = state?.patientId;
  useEffect(() => {
    if (selectedPatient && open) {
      dispatch(getPlanOfCare({ patientId: selectedPatient?.uuid }));
    }
  }, [selectedPatient, open]);

  useEffect(() => {
    if (facilityCaseMixResponse) {
      const ptUpdateList = ptOtLists?.map((pt) => {
        const key = pt?.slice(0, 2);
        let mins;

        if (key === 'TO') mins = facilityCaseMixResponse['tor'];
        else mins = facilityCaseMixResponse[key?.toLocaleLowerCase()];
        return `${key} - ${!!mins ? mins : '0'} mins`;
      });
      setPtOtList(ptUpdateList || []);

      const slpUpdateList = slpLists?.map((slp) => {
        const key = slp?.slice(0, 2);
        let mins;
        mins = facilityCaseMixResponse[key?.toLocaleLowerCase()];
        return `${key} - ${!!mins ? mins : '0'} mins`;
      });
      setSlpList(slpUpdateList || []);
    }
    // if(facilitiesId,)
  }, [facilityCaseMixResponse, facilitiesId]);
  useEffect(() => {
    if (
      assessmentDetailsEditResponse?.isAssessmentUpdated === false &&
      assessmentDetailsEditResponse?.response === null
    )
      return;
    else if (
      assessmentDetailsEditResponse?.isAssessmentUpdated === false &&
      assessmentDetailsEditResponse?.response !== null
    ) {
      setError(
        assessmentDetailsEditResponse?.response?.message ||
          assessmentDetailsEditResponse?.response?.title
      );
      setTimeout(() => {
        dispatch(resetUpdateAssessment());
      }, 3000);
    } else {
      setError(assessmentDetailsEditResponse?.response?.message);
      setTimeout(() => {
        dispatch(resetUpdateAssessment());
        if (state?.from === 'ARD_Tab') {
          navigate(`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`, {
            state: {
              patientId: selectedPatient?.uuid,
              flag: true,
              from_mds: 'ARD_Tab',
            },
          });
        } else {
          navigate('/scheduling/therapy-planning/details', {
            state: {
              patientId: selectedPatient?.uuid,
              flag: true,
            },
          });
        }
      }, 3000);
    }
  }, [assessmentDetailsEditResponse]);

  useEffect(() => {
    if (
      assessmentDetailsCreateResponse?.isAssessmentCreated === false &&
      assessmentDetailsCreateResponse?.response === null
    )
      return;
    else if (
      assessmentDetailsCreateResponse?.isAssessmentCreated === false &&
      assessmentDetailsCreateResponse?.response !== null
    ) {
      setError(
        assessmentDetailsCreateResponse?.response?.message ||
          assessmentDetailsCreateResponse?.response?.title
      );
      setTimeout(() => {
        dispatch(resetCreateAssessment());
      }, 3000);
    } else {
      setError(assessmentDetailsCreateResponse?.response?.message);
      setTimeout(() => {
        dispatch(resetCreateAssessment());
        if (state?.from === 'ARD_Tab') {
          navigate(`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`, {
            state: {
              patientId: selectedPatient?.uuid,
              flag: true,
              from_mds: 'ARD_Tab',
            },
          });
        } else {
          navigate('/scheduling/therapy-planning/details', {
            state: {
              patientId: selectedPatient?.uuid,
              flag: true,
            },
          });
        }
      }, 3000);
    }
  }, [assessmentDetailsCreateResponse]);

  // useEffect(() => {
  //   if (assessmentDetails) {
  //     setAssessmentDate(new Date(assessmentDetails?.assessmentDate));
  //   }
  // }, [assessmentDetails]);
  const [isFinalCaseMixGroup, setFinalCaseMixGroup] = useState(false);

  useEffect(() => {
    if (action === 'Edit' && assessmentDetails?.isFinalMds) {
      setFinalCaseMixGroup(assessmentDetails?.isFinalMds);
    }
  }, [assessmentDetails]);
  const assessmentDateWithoutDateFormat = assessmentDetails?.assessmentDate?.split('T')?.at(0);
  const assesssmentDateWithoutTimezone = new Date(
    new Date(assessmentDateWithoutDateFormat).valueOf() +
      new Date(assessmentDateWithoutDateFormat).getTimezoneOffset() * 60 * 1000
  );

  const assessmentDateFinalDateWithoutTimezone = assessmentDetails?.finalMds?.assessmentDate
    ?.split('T')
    ?.at(0);

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      assessmentDate:
        state?.from === 'ARD_Tab' && action === 'Create'
          ?
          new Date(
            new Date(state?.ARD_Date)?.valueOf() +
            new Date(state?.ARD_Date)?.getTimezoneOffset() *
            60 *
            1000
          )
          : action === 'Edit'
          ? assessmentDetails?.assessmentDate
            ? assesssmentDateWithoutTimezone
            : null
          : null,
      assessmentType: action === 'Edit' ? assessmentDetails?.assessmentType : '',
      ptOt: action === 'Edit' ? assessmentDetails?.mdsPtOtGroup : '',
      slp: action === 'Edit' ? assessmentDetails?.mdsSlpGroup : '',
      nursing: action === 'Edit' ? assessmentDetails?.mdsNursingGroup : '',
      nta: action === 'Edit' ? assessmentDetails?.mdsNtaGroup : '',
      isFinalMds: action === 'Edit' ? assessmentDetails?.isFinalMds : false,
      finalMds: {
        assessmentDate:
          action === 'Edit'
            ? assessmentDetails?.finalMds?.assessmentDate
              ? new Date(
                  new Date(assessmentDateFinalDateWithoutTimezone).valueOf() +
                    new Date(assessmentDateFinalDateWithoutTimezone).getTimezoneOffset() * 60 * 1000
                )
              : null
            : null,
        assessmentType: action === 'Edit' ? assessmentDetails?.finalMds?.assessmentType : '',
        mdsPtOtGroup: action === 'Edit' ? assessmentDetails?.finalMds?.mdsPtOtGroup : '',
        mdsNursingGroup: action === 'Edit' ? assessmentDetails?.finalMds?.mdsNursingGroup : '',
        mdsSlpGroup: action === 'Edit' ? assessmentDetails?.finalMds?.mdsSlpGroup : '',
        mdsNtaGroup: action === 'Edit' ? assessmentDetails?.finalMds?.mdsNtaGroup : '',
      },
    },
    validationSchema: Yup.object({
      assessmentDate: Yup.date()
        .required('Please enter valid Assessment Date')
        .typeError('Please enter valid Assessment Date'),
      assessmentType: Yup.string().max(255).required('Please enter valid Assessment Type'),
      ptOt: Yup.string().required('Please enter valid PT-OT'),
      slp: Yup.string().required('Please enter valid SLP'),
      nursing: Yup.string().required('Please enter valid Nursing'),
      nta: Yup.string().required('Please enter valid NTA'),
      isFinalMds: Yup.boolean(),

      finalMds: Yup.object().when(['isFinalMds'], (isFinalMds, schema) => {
        return isFinalMds[0]
          ? schema.shape({
              assessmentDate: Yup.date()
                .required('Please enter valid Assessment Date')
                .typeError('Please enter valid Assessment Date'),
              assessmentType: Yup.string().max(255).required('Please enter valid Assessment Type'),
              mdsPtOtGroup: Yup.string().required('Please enter valid PT-OT'),
              mdsNursingGroup: Yup.string().required('Please enter valid Nursing'),
              mdsSlpGroup: Yup.string().required('Please enter valid SLP'),
              mdsNtaGroup: Yup.string().required('Please enter valid NTA'),
            })
          : schema.shape({
              assessmentDate: Yup.mixed().nullable(),
              assessmentType: Yup.mixed(),
              mdsPtOtGroup: Yup.mixed(),
              mdsNursingGroup: Yup.mixed(),
              mdsSlpGroup: Yup.mixed(),
              mdsNtaGroup: Yup.mixed(),
            });
      }),
    }),

    onSubmit: async (values, helpers): Promise<void> => {
      if (
        !isDateInRange(moment(values?.assessmentDate || new Date())) &&
        selectedPatient?.planTracking === 'PDPM'
      ) {
        setWarningPopup(true);
        if (action === 'Create') {
          setData({
            patientId: selectedPatient?.uuid,
            moduleType: 'PDPM',
            data: {
              assessmentDate: getCurrentDateUTCWithoutTime(values?.assessmentDate || new Date()),
              assessmentType: values?.assessmentType,
              mdsPtOtGroup: values?.ptOt,
              mdsNursingGroup: values?.nursing,
              mdsSlpGroup: values?.slp,
              mdsNtaGroup: values?.nta,
              isFinalMds: values?.isFinalMds,
              finalMds: values?.isFinalMds
                ? {
                    assessmentDate: getCurrentDateUTCWithoutTime(
                      values?.finalMds?.assessmentDate || new Date()
                    ),
                    assessmentType: values?.finalMds.assessmentType,
                    mdsPtOtGroup: values?.finalMds?.mdsPtOtGroup,
                    mdsNursingGroup: values?.finalMds?.mdsNursingGroup,
                    mdsSlpGroup: values?.finalMds?.mdsSlpGroup,
                    mdsNtaGroup: values?.finalMds?.mdsNtaGroup,
                  }
                : null,
            },
          });
        } else
          setData({
            patientId: selectedPatient?.uuid,
            moduleType: 'PDPM',
            data: {
              uuid: assessmentDetails?.uuid,
              assessmentDate: getCurrentDateUTCWithoutTime(values?.assessmentDate || new Date()),
              assessmentType: values?.assessmentType,
              mdsPtOtGroup: values?.ptOt,
              mdsNursingGroup: values?.nursing,
              mdsSlpGroup: values?.slp,
              mdsNtaGroup: values?.nta,
              isFinalMds: values?.isFinalMds,
              finalMds: values?.isFinalMds
                ? {
                    assessmentDate: getCurrentDateUTCWithoutTime(values?.finalMds?.assessmentDate),
                    assessmentType: values?.finalMds.assessmentType,
                    mdsPtOtGroup: values?.finalMds?.mdsPtOtGroup,
                    mdsNursingGroup: values?.finalMds?.mdsNursingGroup,
                    mdsSlpGroup: values?.finalMds?.mdsSlpGroup,
                    mdsNtaGroup: values?.finalMds?.mdsNtaGroup,
                  }
                : null,
            },
          });
        return;
      }
      if (action === 'Create')
        dispatch(
          createAssessment({
            patientId: selectedPatient?.uuid,
            moduleType: 'PDPM',
            data: {
              assessmentDate: getCurrentDateUTCWithoutTime(values?.assessmentDate || new Date()),
              assessmentType: values?.assessmentType,
              mdsPtOtGroup: values?.ptOt,
              mdsNursingGroup: values?.nursing,
              mdsSlpGroup: values?.slp,
              mdsNtaGroup: values?.nta,
              isFinalMds: values?.isFinalMds,
              finalMds: values?.isFinalMds
                ? {
                    assessmentDate: getCurrentDateUTCWithoutTime(
                      values?.finalMds?.assessmentDate || new Date()
                    ),
                    assessmentType: values?.finalMds.assessmentType,
                    mdsPtOtGroup: values?.finalMds?.mdsPtOtGroup,
                    mdsNursingGroup: values?.finalMds?.mdsNursingGroup,
                    mdsSlpGroup: values?.finalMds?.mdsSlpGroup,
                    mdsNtaGroup: values?.finalMds?.mdsNtaGroup,
                  }
                : null,
            },
          })
        );
      else
        dispatch(
          updateAssessment({
            patientId: selectedPatient?.uuid,
            moduleType: 'PDPM',
            data: {
              uuid: assessmentDetails?.uuid,
              assessmentDate: getCurrentDateUTCWithoutTime(values?.assessmentDate || new Date()),
              assessmentType: values?.assessmentType,
              mdsPtOtGroup: values?.ptOt,
              mdsNursingGroup: values?.nursing,
              mdsSlpGroup: values?.slp,
              mdsNtaGroup: values?.nta,
              isFinalMds: values?.isFinalMds,
              finalMds: values?.isFinalMds
                ? {
                    assessmentDate: getCurrentDateUTCWithoutTime(
                      values?.finalMds?.assessmentDate || new Date()
                    ),
                    assessmentType: values?.finalMds.assessmentType,
                    mdsPtOtGroup: values?.finalMds?.mdsPtOtGroup,
                    mdsNursingGroup: values?.finalMds?.mdsNursingGroup,
                    mdsSlpGroup: values?.finalMds?.mdsSlpGroup,
                    mdsNtaGroup: values?.finalMds?.mdsNtaGroup,
                  }
                : null,
            },
          })
        );
    },
  });

  const onClose = () => {
    setOpen(false);
  };

  const handleWarningPopupClose = () => {
    setWarningPopup(false);
  };

  const normalizeDate = (dateString: any) => {
    if (!dateString) return;
    const utcDate = new Date(dateString?.getTime() + dateString?.getTimezoneOffset() * 60000);
    return utcDate.toISOString()?.split('T')[0];
  };

  const checkValidation = () => {
    const onlyDate = moment(formik.values.assessmentDate).format('YYYY-MM-DD');
    const openEOCAssessment = getMultipleMdsAssessment?.response?.data?.find(
      (mds: any) => mds.status === 'OPENED'
    )?.mdsAssessments;

    if (action === 'Edit') {
      const filteredList = openEOCAssessment?.filter(
        (mds: any) => mds.uuid !== assessmentDetails.uuid
      );
      return (
        filteredList?.some((mds: any) => {
          if (mds?.isFinalMds) {
            return (
              mds?.finalMds?.assessmentDate?.split('T')[0] === onlyDate &&
              mds?.finalMds?.assessmentType === formik.values.assessmentType
            );
          }
          return (
            mds?.assessmentDate?.split('T')[0] === onlyDate &&
            mds?.assessmentType === formik.values.assessmentType
          );
        }) ?? false
      );
    }

    return (
      openEOCAssessment?.some((mds: any) => {
        if (mds?.isFinalMds) {
          return (mds?.finalMds?.assessmentDate?.split('T')[0] === onlyDate &&
            mds?.finalMds?.assessmentType === formik.values.assessmentType)
        }
        return (
          mds?.assessmentDate?.split('T')[0] === onlyDate &&
          mds?.assessmentType === formik.values.assessmentType
        );
      }) ?? false
    );
  };
  const [deleteMdsAssessment, setDeleteMdsAssessment] = useState(false);

  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [message, setMessage] = useState('');

  const handleDeleteMds = () => {
    dispatch(
      deleteSingleMdsAssessment({
        mdsId: assessmentDetails?.uuid,
      })
    );
  };

  const handleDeleteMdsAssessment = (mds: any) => {
    setDeleteMdsAssessment(true);
  };

  const deleteMdsAssessmentDate = useSelector(
    (state: any) => state.deleteSingleMdsAssessmentReducer
  );
  useEffect(() => {
    if (
      deleteMdsAssessmentDate?.isMdsAssessmentDeleted === false &&
      deleteMdsAssessmentDate?.response === null
    )
      return;
    if (
      deleteMdsAssessmentDate?.isMdsAssessmentDeleted === false &&
      deleteMdsAssessmentDate !== null
    ) {
      setMessage(deleteMdsAssessmentDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setIsSnackBarOpen(false);
        dispatch(resetDeleteSingleMdsAssessment());
        setMessage('');
      }, 3000);
      return;
    } else {
      setDeleteMdsAssessment(false);
      setMessage(deleteMdsAssessmentDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setMessage('');
        setIsSnackBarOpen(false);
        dispatch(resetDeleteSingleMdsAssessment());
        if (state?.from === 'ARD_Tab') {
          navigate(`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`, {
            state: {
              patientId: selectedPatient?.uuid,
              flag: true,
              from_mds: 'ARD_Tab',
            },
          });
        } else {
          navigate('/scheduling/therapy-planning/details', {
            state: {
              patientId: selectedPatient?.uuid,
              flag: true,
            },
          });
        }
      }, 3000);
    }
  }, [deleteMdsAssessmentDate]);

  return (
    <>
      <Stack sx={{ margin: '36px 74px', gap: '1.5rem' }}>
        <Stack gap="1.5rem">
          <Stack
            flexDirection="row"
            gap=".5rem"
            alignItems="center"
          >
            <Link
              variant="body2"
              sx={{ display: 'flex', gap: 1, alignItems: 'center', cursor: 'pointer' }}
              color="#6C737F"
              onClick={() => {
                if (state?.from === 'ARD_Tab') {
                  navigate(
                    `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`,
                    {
                      state: {
                        patientId: selectedPatient?.uuid,
                        flag: true,
                        from_mds: 'ARD_Tab',
                      },
                    }
                  );
                } else {
                  navigate('/scheduling/therapy-planning/details', {
                    state: {
                      patientId: selectedPatient?.uuid,
                      flag: true,
                    },
                  });
                }
              }}
            >
              <IconButton sx={{ margin: '0', padding: '0' }}>
                <ArrowBackOutlined fontSize="small" />
              </IconButton>
              <Typography
                sx={{ color: '#6C737F' }}
                variant="subtitle2"
              >
                {state?.from === 'ARD_Tab' ? 'Back to Therapy Planning' : 'Back to MDS assessment'}
              </Typography>
            </Link>
          </Stack>
        </Stack>
        <Typography
          sx={{ padding: '0 24px' }}
          variant="h4"
        >
          {action === 'Create'
            ? 'Therapy Planning - Create MDS Assessment'
            : 'Therapy Planning - Edit Assessment Details'}
        </Typography>
        <Divider sx={{ border: '1px solid #E5E7EB' }} />
        <Stack
          gap="1rem"
          sx={{ padding: '0 24px' }}
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack
            gap="1rem"
            flexDirection="row"
          >
            <Avatar
              src={`data:image/png;base64,${selectedPatient?.profileImage}`}
              sx={{ textTransform: 'uppercase' }}
            >{`${selectedPatient?.lastName?.at(0) || ''}${
              selectedPatient?.firstName?.at(0) || ''
            }`}</Avatar>
            <Stack>
              <Typography variant="h5">{`${selectedPatient?.lastName} ${selectedPatient?.firstName}`}</Typography>
              <Typography
                sx={{ display: 'flex', gap: '.5rem', marginTop: '5px' }}
                variant="captionText"
              >
                <img
                  src={patientListIcon}
                  alt=""
                />
                {selectedPatient?.planTracking ? selectedPatient?.planTracking : '-'}
              </Typography>
            </Stack>
          </Stack>

          <Button
            sx={{ height: 'max-content', padding: '6px 14px', gap: '.5rem' }}
            variant="outlined"
            onClick={() => setOpen(true)}
          >
            <img
              src={planOfCareIcon}
              alt=""
            />
            Plan of Care
          </Button>
        </Stack>
        <Card
          sx={{
            padding: '24px',
            margin: '0 24px',
            display: 'flex',
            borderRadius: '16px',
            flexDirection: 'column',
            gap: '2rem',
          }}
        >
          <form
            onSubmit={formik.handleSubmit}
            style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}
          >
            <Stack gap="1.5rem">
              <Typography variant="customHeading">Initial Assessment</Typography>
              {/* <Typography variant="subtitle1">{' Basic Details'}</Typography> */}
            </Stack>
            <Grid
              spacing={3}
              container
            >
              <Grid
                item
                xs={6}
              >
                <DatePicker
                  onChange={(newDate) => {
                    formik.setFieldValue('assessmentDate', newDate);
                  }}
                  label="Assessment Date"
                  value={formik.values.assessmentDate}
                  minDate={
                    new Date(
                      new Date(eocStartDateWithoutTimeZone || '01-01-1900').valueOf() +
                        new Date(eocStartDateWithoutTimeZone || '01-01-1900').getTimezoneOffset() *
                          60 *
                          1000
                    )
                  }
                  format="MM dd, yyyy"
                  sx={{
                    width: '100%',
                    border:
                      formik.touched.assessmentDate && formik.errors.assessmentDate
                        ? '3px solid #F04438'
                        : '',
                    borderRadius:
                      formik.touched.assessmentDate && formik.errors.assessmentDate ? '10px' : '',
                  }}
                />
                {formik.touched.assessmentDate && formik.errors.assessmentDate && (
                  <Typography
                    padding={'0px 16px'}
                    color={'#F04438'}
                    variant="caption"
                  >
                    {formik.errors.assessmentDate}
                  </Typography>
                )}
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  defaultValue={'COMMERCIAL_INSURANCE'}
                  fullWidth
                  error={!!(formik.touched.assessmentType && formik.errors.assessmentType)}
                  helperText={
                    formik.touched.assessmentType && (formik.errors.assessmentType as any)
                  }
                  name="assessmentType"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.assessmentType}
                  label="Assessment Type"
                  select
                >
                  {assessmentTypeList?.map((type) => (
                    <MenuItem
                      key={type}
                      value={type}
                    >
                      {type}
                    </MenuItem>
                  ))}
                </TextField>
                {checkValidation() && (
                  <Typography
                    padding={'5px 14px'}
                    color={'#F04438'}
                    variant="caption"
                    sx={{ display: 'block' }}
                  >
                    An assessment with this type and date already exists for this patient. Please
                    edit the existing record
                  </Typography>
                )}
              </Grid>
            </Grid>
            {/* <Typography variant="subtitle1">{'Case-Mix Group - Anticipated'}</Typography> */}
            <Grid
              spacing={3}
              container
            >
              <Grid
                item
                xs={6}
              >
                <TextField
                  defaultValue={'COMMERCIAL_INSURANCE'}
                  fullWidth
                  error={!!(formik.touched.ptOt && formik.errors.ptOt)}
                  helperText={formik.touched.ptOt && (formik.errors.ptOt as any)}
                  name="ptOt"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.ptOt}
                  SelectProps={{
                    MenuProps: MenuProps,
                  }}
                  label="MDS PT-OT Case-mix Group"
                  select
                >
                  <MenuItem
                    key={'Not Applicable'}
                    value={'Not Applicable'}
                  >
                    Not Applicable
                  </MenuItem>
                  {ptOtList?.map((list: any) => (
                    <MenuItem
                      key={list}
                      value={list}
                    >
                      {list}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  defaultValue={'COMMERCIAL_INSURANCE'}
                  fullWidth
                  label="MDS SLP Case-mix Group"
                  error={!!(formik.touched.slp && formik.errors.slp)}
                  helperText={formik.touched.slp && (formik.errors.slp as any)}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.slp}
                  SelectProps={{
                    MenuProps: MenuProps,
                  }}
                  name="slp"
                  select
                >
                  <MenuItem
                    key={'Not Applicable'}
                    value={'Not Applicable'}
                  >
                    Not Applicable
                  </MenuItem>
                  {slpList.map((list: any) => (
                    <MenuItem
                      key={list}
                      value={list}
                    >
                      {list}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  defaultValue={'COMMERCIAL_INSURANCE'}
                  fullWidth
                  label="MDS Nursing Case-mix Group"
                  error={!!(formik.touched.nursing && formik.errors.nursing)}
                  helperText={formik.touched.nursing && (formik.errors.nursing as any)}
                  name="nursing"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.nursing}
                  SelectProps={{
                    MenuProps: MenuProps,
                  }}
                  select
                >
                  <MenuItem
                    key={'Not Applicable'}
                    value={'Not Applicable'}
                  >
                    Not Applicable
                  </MenuItem>
                  {caseMixGroup?.map((value) => (
                    <MenuItem
                      key={value}
                      value={value}
                    >
                      {value}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  defaultValue={'COMMERCIAL_INSURANCE'}
                  fullWidth
                  label="MDS NTA Case-mix Group"
                  name="nta"
                  error={!!(formik.touched.nta && formik.errors.nta)}
                  helperText={formik.touched.nta && (formik.errors.nta as any)}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.nta}
                  SelectProps={{
                    MenuProps: MenuProps,
                  }}
                  select
                >
                  <MenuItem
                    key={'Not Applicable'}
                    value={'Not Applicable'}
                  >
                    Not Applicable
                  </MenuItem>
                  {ntaCaseMixGroup?.map((value) => (
                    <MenuItem
                      key={value}
                      value={value}
                    >
                      {value}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
            <Grid
              display={'flex'}
              justifyContent={'space-between'}
            >
              <Box>
                <Typography
                  sx={{ fontSize: '16px', color: '#111927' }}
                  variant="subtitle1"
                >
                  {/* {action === 'Edit' ? 'Edit Case-mix Group Details' : 'Add Case-mix Group Details'} */}
                  Finalize Assessment
                </Typography>
                <Typography
                  sx={{ color: '#6C737F', fontSize: '14px' }}
                  variant="subtitle1"
                >
                  Finalize the case-mix details for this assessment
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Switch
                  checked={isFinalCaseMixGroup}
                  onChange={(e) => {
                    formik.setFieldValue('isFinalMds', e.target.checked);
                    formik.setFieldValue('finalMds.assessmentDate', formik.values.assessmentDate);
                    formik.setFieldValue('finalMds.assessmentType', formik.values.assessmentType);
                    formik.setFieldValue('finalMds.mdsPtOtGroup', formik.values.ptOt);
                    formik.setFieldValue('finalMds.mdsNursingGroup', formik.values.nursing);
                    formik.setFieldValue('finalMds.mdsSlpGroup', formik.values.slp);
                    formik.setFieldValue('finalMds.mdsNtaGroup', formik.values.nta);

                    setFinalCaseMixGroup(e.target.checked);
                  }}
                />
              </Box>
            </Grid>
            {isFinalCaseMixGroup ? (
              <FinalBasicDetailsMdsAssessment
                slpList={slpList}
                formik={formik}
                selectedPatient={selectedPatient}
                caseMixGroup={caseMixGroup}
                ptOtList={ptOtList}
              />
            ) : null}

            <Stack
              flexDirection="row"
              gap="1rem"
              justifyContent={action === 'Edit' ? 'space-between' : 'flex-end'}
            >
              {action === 'Edit' && (
                <IconButton
                  onClick={handleDeleteMdsAssessment}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '11.765px',
                    background: 'var(--error-light, #FEE4E2)',
                    '&:hover': {
                      background: 'var(--error-light, #FEE4E2)',
                    },
                  }}
                >
                  <TrashIcon />
                </IconButton>
              )}
              <Stack
                flexDirection="row"
                gap="1rem"
              >
                <Button
                  variant="text"
                  sx={{ color: '#111927', fontSize: '14px', fontWeight: '600' }}
                  onClick={() => {
                    if (state?.from === 'ARD_Tab') {
                      navigate(
                        `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.info}`,
                        {
                          state: {
                            patientId: selectedPatient?.uuid,
                            flag: true,
                            from_mds: 'ARD_Tab',
                          },
                        }
                      );
                    } else {
                      navigate('/scheduling/therapy-planning/details', {
                        state: {
                          patientId: selectedPatient?.uuid,
                          flag: true,
                        },
                      });
                    }
                  }}
                >
                  Cancel
                </Button>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  disabled={checkValidation()}
                  loading={assessmentDetailsCreateResponse?.loading}
                >
                  {action === 'Create' ? 'Save' : 'Save Details'}
                </LoadingButton>
              </Stack>
            </Stack>
          </form>
        </Card>
        <Grid />
      </Stack>
      <Modal
        open={warningPopup}
        onClose={handleWarningPopupClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            flexDirection="row"
            gap="1rem"
            alignItems={'center'}
          >
            <img
              src={discardIcon}
              width="40px"
              height="40px"
              alt=""
            />
            <Stack gap=".75rem">
              <Typography
                id="modal-modal-title"
                variant="h5"
              >
                Assessment date for PDPM patient{' '}
              </Typography>
              <Typography
                id="modal-modal-title"
                variant="caption2Text"
              >
                The assessment date should be within the first 8 days of treatment for PDPM
                patients.Do you still want to proceed ?
              </Typography>
            </Stack>
          </Stack>
          <Stack
            flexDirection="row"
            gap="1rem"
            justifyContent="flex-end"
            sx={{ marginTop: '1rem' }}
          >
            <Button
              onClick={handleWarningPopupClose}
              color="inherit"
            >
              No
            </Button>
            <Button
              variant="contained"
              color={action === 'Edit' ? 'primary' : 'error'}
              onClick={() => {
                if (action === 'Create') dispatch(createAssessment(data));
                else dispatch(updateAssessment(data));
                handleWarningPopupClose();
                setData(null);
              }}
            >
              Yes
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Drawer
        anchor="right"
        onClose={onClose}
        open={open}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: 500,
          },
        }}
      >
        <Stack>
          <Stack
            justifyContent="space-between"
            sx={{ margin: '1.5rem' }}
            flexDirection="row"
          >
            <Typography variant="h5">{`${selectedPatient?.name}'s Plan of Care`}</Typography>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider />
          <Stack
            gap="1rem"
            sx={{ margin: '1.3rem' }}
          >
            <Stack
              sx={{ marginTop: '1rem' }}
              gap=".75rem"
            >
              <Typography
                variant="subtitle2"
                color="primary"
              >
                DIAGNOSIS
              </Typography>
              <Stack
                flexWrap="wrap"
                gap="1rem"
                flexDirection="row"
              >
                {planOfCareDetails?.diagnosis?.map((name: any, index: any) => (
                  <>
                    <Typography
                      key={index}
                      variant="body1"
                    >
                      {name}
                    </Typography>
                    {index != planOfCareDetails?.diagnosis?.length - 1 && (
                      <Typography variant="body1">,</Typography>
                    )}
                  </>
                ))}
              </Stack>
            </Stack>
            <Divider />
            <Stack
              gap="1rem"
              alignItems="center"
              flexDirection="row"
            >
              <Chip
                variant="outlined"
                label={'OT'}
              />
              <CalendarMonthIcon />
              <Typography>
                {planOfCareDetails?.disciplineMap?.OT ? planOfCareDetails?.disciplineMap?.OT : '-'}
              </Typography>
            </Stack>
            <Stack
              gap="1rem"
              alignItems="center"
              flexDirection="row"
            >
              <Chip
                variant="outlined"
                label={'PT'}
              />
              <CalendarMonthIcon />
              <Typography>
                {planOfCareDetails?.disciplineMap?.PT ? planOfCareDetails?.disciplineMap?.PT : '-'}
              </Typography>
            </Stack>
            <Stack
              gap="1rem"
              alignItems="center"
              flexDirection="row"
            >
              <Chip
                variant="outlined"
                label={'SLP'}
              />
              <CalendarMonthIcon />
              <Typography>
                {planOfCareDetails?.disciplineMap?.SLP
                  ? planOfCareDetails?.disciplineMap?.SLP
                  : '-'}
              </Typography>
            </Stack>
            <Divider />
            <Stack
              flexDirection="row"
              gap="1rem"
            >
              <Box
                sx={{
                  width: '35px',
                  height: '35px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#e8edff',
                  borderRadius: '12px',
                }}
              >
                <WorkspacePremiumOutlinedIcon />
              </Box>
              <Stack>
                <Typography variant="body2">Goals</Typography>
                {planOfCareDetails?.goals?.map((goal: any) => (
                  <Typography
                    key={goal}
                    variant="body2"
                  >
                    {goal}
                  </Typography>
                ))}
              </Stack>
            </Stack>
            <Divider />
            <Stack
              flexDirection="row"
              gap="1rem"
            >
              <Box
                sx={{
                  width: '35px',
                  height: '35px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#e8edff',
                  borderRadius: '12px',
                }}
              >
                <WorkspacePremiumOutlinedIcon />
              </Box>
              <Stack gap=".5rem">
                <Typography variant="body2">Codes</Typography>
                <Stack
                  gap="1rem"
                  flexDirection="row"
                  flexWrap={'wrap'}
                >
                  {planOfCareDetails?.codes?.map((planOfCare: any) => (
                    <Chip
                      variant="outlined"
                      label={`${planOfCare} | ${
                        planOfCareDetails?.cptCodeDescription[planOfCare] || ''
                      } `}
                    />
                  ))}
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Drawer>
      {(assessmentDetailsEditResponse?.response !== null ||
        assessmentDetailsCreateResponse?.response !== null) && (
        <SimpleSnackbar
          message={error}
          isError={
            (!assessmentDetailsEditResponse?.isAssessmentUpdated &&
              assessmentDetailsEditResponse?.response !== null) ||
            (!assessmentDetailsCreateResponse?.isAssessmentCreated &&
              assessmentDetailsCreateResponse?.response !== null)
          }
        />
      )}

      <BootstrapDialog
        onClose={() => setDeleteMdsAssessment(false)}
        aria-labelledby="customized-dialog-title"
        open={deleteMdsAssessment}
      >
        <DeletePopupModal
          close={() => setDeleteMdsAssessment(false)}
          message={'This action cannot be undone.'}
          button={{ saveLabel: 'Delete', closeLabel: 'Cancel' }}
          title={'Delete MDS Assessment?'}
          handleSaveBtn={handleDeleteMds}
        />
      </BootstrapDialog>
      {isSnackBarOpen && (
        <SimpleSnackbar
          message={message}
          isWarning={false}
        />
      )}
    </>
  );
};

export default TherapyPlanningEditDetails;
